import {Base} from "@/api/Base"

export class UploadRecordDelete extends Base {
    path = "uploadRecord/delete"
}